import shippingOptionsData from './shippingOptionsData.json';

export default {
    data: shippingOptionsData
};